import { render, staticRenderFns } from "./ReportMessageShareCampaign.vue?vue&type=template&id=057f5f8b&scoped=true&"
import script from "./ReportMessageShareCampaign.vue?vue&type=script&lang=js&"
export * from "./ReportMessageShareCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f5f8b",
  null
  
)

export default component.exports